"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var TGCPreviewContent = function (_a) {
    var children = _a.children;
    (0, react_2.useEffect)(function () {
        document.querySelectorAll("tgcs-audio").forEach(function (el) {
            el.addEventListener("click", function () {
                var audio = el.querySelector("audio");
                if (audio.paused) {
                    audio.play().catch(console.error);
                }
                else {
                    audio.load();
                }
            });
        });
    }, [children]);
    return react_1.default.createElement("div", { className: "tgc-preview--content" }, children);
};
exports.default = TGCPreviewContent;
